import type { Pagination, ProductLine } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/lines';

export function getProductLines(query: ProductLine.SearchQuery) {
    return api.get<Pagination<ProductLine>>(rootPath, query);
}

export function getProductLine(id: number) {
    return api.get<ProductLine.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postProductLine(data: ProductLine.CreateRequest) {
    return api.post<ProductLine>(rootPath, data);
}

export function putProductLine(id: number, data: ProductLine.UpdateRequest) {
    return api.put<ProductLine>(`${rootPath}/${id}`, data);
}

export function deleteProductLine({ id }: ProductLine.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
